import React from 'react';
export function ProductSection() {
  return <section className="w-full px-4 py-10 md:py-16 bg-[#0a0f1a]" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <h2 className="text-xl md:text-2xl font-bold text-gray-300 mb-2 text-center" data-id="element-114">
          Por eso creamos:
        </h2>

        <h3 className="text-3xl md:text-4xl font-bold text-[#D4A843] mb-8 text-center" data-id="element-115">
          LIBERACIÓN MIOFASCIAL PRO
        </h3>

        <p className="text-base md:text-lg text-gray-300 mb-4 text-center" data-id="element-116">
          Un sistema completo diseñado para transformar la forma en la que
          trabajás.
        </p>

        <p className="text-base md:text-lg text-gray-300 mb-4 text-center" data-id="element-117">
          No es otro curso más.
        </p>

        <p className="text-base md:text-lg text-gray-300 mb-8 text-center" data-id="element-118">
          Es un método estructurado que te enseña:
        </p>

        <div className="bg-[#050810] border border-[#D4A843]/30 p-5 md:p-6 rounded-lg mb-8" data-id="element-119">
          <ul className="space-y-3" data-id="element-120">
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-121">
              <span className="text-[#D4A843] mr-3 text-xl" data-id="element-122">✔</span>
              <span data-id="element-123">A aumentar el valor de tus sesiones</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-124">
              <span className="text-[#D4A843] mr-3 text-xl" data-id="element-125">✔</span>
              <span data-id="element-126">Aplicar técnicas efectivas paso a paso</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-127">
              <span className="text-[#D4A843] mr-3 text-xl" data-id="element-128">✔</span>
              <span data-id="element-129">Estructurar sesiones profesionales</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-130">
              <span className="text-[#D4A843] mr-3 text-xl" data-id="element-131">✔</span>
              <span data-id="element-132">Lograr resultados en menos sesiones</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-133">
              <span className="text-[#D4A843] mr-3 text-xl" data-id="element-134">✔</span>
              <span data-id="element-135">Posicionarte como especialista</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-r from-[#050810] to-[#0a0f1a] border-l-4 border-[#D4A843] p-5 md:p-6 rounded-lg" data-id="element-136">
          <h5 className="text-xl md:text-2xl font-bold text-[#D4A843] mb-4" data-id="element-137">
            Incluye:
          </h5>
          <ul className="space-y-3" data-id="element-138">
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-139">
              <span className="text-[#D4A843] mr-3" data-id="element-140">●</span>
              <span data-id="element-141">Un total de +250 páginas de contenido</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-142">
              <span className="text-[#D4A843] mr-3" data-id="element-143">●</span>
              <span data-id="element-144">Fundamentos claros</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-145">
              <span className="text-[#D4A843] mr-3" data-id="element-146">●</span>
              <span data-id="element-147">Técnicas prácticas</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-148">
              <span className="text-[#D4A843] mr-3" data-id="element-149">●</span>
              <span data-id="element-150">Protocolos listos para usar</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-151">
              <span className="text-[#D4A843] mr-3" data-id="element-152">●</span>
              <span data-id="element-153">Casos reales</span>
            </li>
            <li className="text-base md:text-lg text-gray-300 flex items-start" data-id="element-154">
              <span className="text-[#D4A843] mr-3" data-id="element-155">●</span>
              <span data-id="element-156">
                Herramientas para mejorar tu posicionamiento profesional
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}